<script lang="ts">
  import Alert from './alert.svelte';
  import Confirm from './confirm.svelte';
  import Code from './code.svelte';
  import SelectDie from './select-die.svelte';
  import SelectFace from './select-face.svelte';
  import Options from './options.svelte';
  import Prompt from './prompt.svelte';
  import Ammo from './ammo.svelte';
  import Inventory from './inventory.svelte';
  import Tutorial from './tutorial.svelte';
</script>

<Alert></Alert>
<Confirm></Confirm>
<Code></Code>
<SelectDie></SelectDie>
<SelectFace></SelectFace>
<Options></Options>
<Prompt></Prompt>
<Ammo></Ammo>
<Inventory></Inventory>
<Tutorial></Tutorial>
